export default __webpack_public_path__ + "static/media/beetroot_salad.54a3b2c5.jpg";